import { render, staticRenderFns } from "./ServicesTabs.vue?vue&type=template&id=0133a45b&"
import script from "./ServicesTabs.vue?vue&type=script&lang=js&"
export * from "./ServicesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports